import TrashIcon from './component'

export default TrashIcon
